import { useEffect, useState } from "react";

export default function MiamiHeroSection() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Nav */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center gap-2">
            <img
              src="https://staging.fastpassportcenter.com/wp-content/uploads/2026/02/Fast-Passport-Center.png"
              alt="Fast Passport Center"
              className="h-8 md:h-9 w-auto"
            />
          </a>
          <div className="hidden md:flex items-center gap-8">
            {[
              { label: "Services", href: "#services" },
              { label: "How It Works", href: "#how-it-works" },
              { label: "FAQ", href: "#faq" },
              { label: "Resources", href: "#local-resources" },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-semibold transition-colors ${
                  scrolled
                    ? "text-[#1A365D] hover:text-[#F6C344]"
                    : "text-white hover:text-[#F6C344]"
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
          >
            Start My Passport
          </a>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative h-[500px] md:h-[640px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Aerial%20panoramic%20view%20of%20Miami%20Florida%20skyline%20at%20sunset%20with%20Biscayne%20Bay%20turquoise%20water%2C%20modern%20skyscrapers%20along%20Brickell%20Avenue%2C%20cruise%20ships%20at%20PortMiami%2C%20palm%20trees%20and%20tropical%20atmosphere%2C%20golden%20hour%20warm%20light%20reflecting%20on%20water%2C%20photorealistic%20cityscape%20photography%2C%20South%20Florida%20coastal%20urban%20landscape&width=1600&height=700&seq=miahero1&orientation=landscape"
            alt="Miami skyline at sunset with Biscayne Bay and downtown skyscrapers"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
        </div>

        <div className="relative z-10 text-center max-w-4xl mx-auto px-4 md:px-8 pt-16">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-4">
            Miami, FL — Expedited Passport Service
          </p>
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Get Your Passport Fast in Miami — <span className="text-[#F6C344]">Same-Day Processing</span> Available
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            From South Beach to Brickell to Little Havana — travelers across Miami-Dade County trust Fast Passport Center for emergency and expedited passports. As fast as 24 hours. Start online, ship overnight, skip the agency lines.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold text-base px-6 py-4 rounded-md transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line"></i> 877-253-0084
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-5 mt-10 text-white/60 text-xs">
            {[
              { icon: "ri-shield-check-line", text: "State Dept. Registered Courier" },
              { icon: "ri-award-line", text: "A+ BBB Rating" },
              { icon: "ri-time-line", text: "20+ Years Experience" },
              { icon: "ri-customer-service-2-line", text: "Live U.S.-Based Support" },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-1.5">
                <i className={`${badge.icon} text-[#F6C344]`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}